export default "__VITE_ASSET__C$lqRhrI__"